import { render, staticRenderFns } from "./ChatVideoAcceptor.vue?vue&type=template&id=4f8843e6&scoped=true"
import script from "./ChatVideoAcceptor.vue?vue&type=script&lang=js"
export * from "./ChatVideoAcceptor.vue?vue&type=script&lang=js"
import style0 from "./ChatVideoAcceptor.vue?vue&type=style&index=0&id=4f8843e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8843e6",
  null
  
)

export default component.exports